export class TimecardTypes {
    public static readonly ALL = {label: 'All', value: 'all'};
    public static readonly TIPPED = {label: 'Tipped', value: 'true'};
    public static readonly UNTIPPED = {label: 'Un-tipped', value: 'false'};
}
